import { render, staticRenderFns } from "./ManageExpenseAdminPlus.vue?vue&type=template&id=6d834a76&scoped=true"
import script from "./ManageExpenseAdminPlus.vue?vue&type=script&lang=js"
export * from "./ManageExpenseAdminPlus.vue?vue&type=script&lang=js"
import style0 from "./ManageExpenseAdminPlus.vue?vue&type=style&index=0&id=6d834a76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d834a76",
  null
  
)

export default component.exports